import { NgClass, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { OverlayBadge } from 'primeng/overlaybadge';
import { Tooltip } from 'primeng/tooltip';
import { AuthService } from '../../../core/services/auth.service';
import { I18nService } from '../../../core/services/i18n.service';

@Component({
  selector: 'sps-toolbar-item',
  imports: [
    NgStyle,
    NgClass,
    Tooltip,
    OverlayBadge
  ],
  templateUrl: './topbar-menu-item.component.html'
})
export class TopbarMenuItemComponent {

  @Input() name: string = '';
  @Input() icon: string = '';
  @Input() size: string = '1.5rem';
  @Input() i18nTooltipKey: string = null;
  @Input() tooltipText: string = '';
  @Input() showBadge: boolean = false;
  @Input() badgeValue: number = 0;
  @Input() severity: any = null;

  constructor(public i18n: I18nService,
              public authService: AuthService) {
  }

}
